import ImagesUrl from "#constants/images.js";

export const NotFound = ({ title }) => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center w-100"
      style={{ height: "45vh" }}
    >
      <img
        src={ImagesUrl.notFound}
        style={{ marginLeft: "15px", marginBottom: "2px" }}
        width={110}
        alt="not_found"
      />
      <h3>{title ? title : "Data Not Found"}</h3>
    </div>
  );
};
